import React, {Component} from 'react';
import PlayBtn from '../../assets/play_btn.svg';
import AppleBtn from '../../assets/apple_btn.svg';
import './cta.css';

export default class CTA extends Component {

  render(){
    return (
      <div className='gmc__cta-content_buttons'>
        <a href='#button' aria-label='get app from playstore'>
          <img src={PlayBtn} alt="Play Store Button"/>
        </a>
        <a href='#button'  aria-label='get app from appstore'>
          <img src={AppleBtn} alt="Apple Store Button"/>
        </a>
      </div>
    );
  }
}